/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import SoftBadge from "../../components/SoftBadge";
import fixTableCellWidth from "../../utils/fixTableCellWidth";
import TableHeadItems from './TableHeadItems';
import useModal from "hooks/useModal";
import InvestmentOpportunityDetailModal from './InvestmentOpportunityDetailModal';

function createData(id, monthly_roi, name, company_name, type_name, yearly_roi, is_open, is_active, operation) {
    return {
        id,
        monthly_roi,
        name,
        company_name,
        type_name,
        yearly_roi,
        is_open,
        is_active,
        operation
    };
}

function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("160px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.company_name}
                    style={fixTableCellWidth("160px")}>{row.company_name}</TableCell>
                <TableCell className="tablecell" align="left" title={Math.ceil(Number(row.monthly_roi) * 100)}
                    style={fixTableCellWidth("100px")}>{Math.ceil(Number(row.monthly_roi) * 100)}%</TableCell>
                <TableCell className="tablecell" align="left" title={Math.ceil(Number(row.yearly_roi) * 100)}
                    style={fixTableCellWidth("100px")}>{Math.ceil(Number(row.yearly_roi) * 100)}%</TableCell>
                <TableCell className="tablecell" align="left" title={row.type_name}
                    style={fixTableCellWidth("140px")}>{row.type_name}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("140px")}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function InvestmentOpportunityTable({ data, filterInfo, handleFilterChange, onFilterClick }) {
    const navigate = useNavigate()
    const [modals, updateModal, closeModal] = useModal({
        investmentDetail: { state: false },
    });
    const closeInvestmentDetailModal = () => closeModal("investmentDetail");

    const rows = data.map(item => createData(item.id, item.monthly_roi, item.name, item?.company?.name, item.type_name, item.yearly_roi, item.is_open, item.is_active, <section style={{ display: "flex", cursor: 'pointer' }}>
        {/* <SoftBadge variant="contained"
            onClick={() => navigate(`/ghollakMinBalance?investment_id=${item.id}`)}
            badgeContent="تاریخچه موجودی قلک"
            color="primary" size="xs" /> */}
        <SoftBadge variant="contained"
            onClick={() => updateModal(`investmentDetail`, { state: true, item })}
            badgeContent="اطلاعات بیشتر"
            color="success" size="xs" />
        <SoftBadge variant="contained"
            onClick={() => navigate(`/new-investment-opportunity?method=update`, { state: item })}
            badgeContent="آپدیت"
            color="secondary" size="xs" />
    </section>
    ))

    return (
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <SoftBadge onClick={() => navigate("/new-investment-opportunity")} variant="contained"
                        badgeContent="فرصت سرمایه گذاری جدید" color="success" size="xs"
                        container
                        style={{ cursor: 'pointer' }} />
                    <TableHeadItems filterInfo={filterInfo} handleFilterChange={handleFilterChange} onFilterClick={onFilterClick} />
                    <TableRow>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام شرکت</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("100px")}>سود ماهانه</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("100px")}>سود سالانه</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نوع</TableCell>
                        <TableCell className="tablecell" style={fixTableCellWidth("140px")}>عملیات ها</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody style={{ display: 'block' }}>
                    {rows.map((row) => (
                        <Row key={row.id} row={row} />
                    ))}
                </TableBody>
            </Table>
            {modals.investmentDetail.state && <InvestmentOpportunityDetailModal modalInfo={modals.investmentDetail} closeModal={closeInvestmentDetailModal} />}
        </TableContainer>
    );
}
